import React from "react";
import { cn } from "../../lib/utils";

const ButtonWithSpinner = ({ loading, children, className, variant = "default", disabled, ...rest }) => {
  const base = "relative inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:pointer-events-none disabled:opacity-50 px-4 py-2";
  const variants = {
    default: "bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm",
    outlined: "border border-slate-200 dark:border-slate-700 bg-transparent text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800",
    contained: "bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm",
  };

  return (
    <button
      className={cn(base, variants[variant] || variants.default, className)}
      disabled={loading || disabled}
      {...rest}
    >
      {loading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin opacity-70" />
        </span>
      )}
      <span className={cn("flex items-center gap-2", loading && "opacity-0")}>{children}</span>
    </button>
  );
};

export default ButtonWithSpinner;
